import React from 'react';

import SideBox from '@/components/SideBox';

import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';

import { ReactComponent as MfFile } from '@/assets/icons/file-text.svg';
import { ReactComponent as MfIndicator } from '@/assets/icons/indicator.svg';
import { ReactComponent as MfUser } from '@/assets/icons/user-2.svg';
import { FiServer } from 'react-icons/fi';

import { useExecucaoContext } from '@/features/execucao/providers/ExecucaoProvider';
import { NavLink, useRouteMatch } from 'react-router-dom';
import SideBoxHistoricoInteracoes from '../SideBoxHistoricoInteracoes';

import { protocoloEnterpriseRoute } from '../../helpers';
import DadosAtendimento from '../DadosAtendimento';
import DadosSumario from '../DadosSumario';
import {
  Container,
  SideBoxButton,
  SideBoxInfoPopup,
  SideBoxInfoPopupIndicator,
  SideBoxWrapper,
  EnterpriseLogo,
} from './styles';

const EnterpriseSidebar: React.FC = () => {
  const { user } = useAuth();
  const { path } = useRouteMatch();
  const [{ protocoloExecutado }] = useExecucaoContext();

  const [isHistorySideOpen, setHistorySideOpen] = React.useState(false);
  const [showAtendimentoInfo, setShowAtendimentoInfo] = React.useState(false);
  const [showAtendimentoSumario, setShowAtendimentoSumario] = React.useState(
    false,
  );

  const Logo = React.useMemo(() => {
    if (user && user.empresa && user.empresa.logo) {
      return <EnterpriseLogo src={user.empresa.logo} alt={user.empresa.nome} />;
    }

    return undefined;
  }, [user]);

  const hasSumario = React.useMemo(
    () => !!protocoloExecutado?.sumario?.length,
    [protocoloExecutado],
  );

  const anyRendered = React.useMemo(
    () => protocoloExecutado?.sumario?.every(item => !item.texto_renderizado),
    [protocoloExecutado],
  );

  const disabledNavigation = React.useMemo(() => path.includes('resumo'), [
    path,
  ]);

  return (
    <Container>
      <SideBoxHistoricoInteracoes
        isOpen={isHistorySideOpen}
        onCloseSideBox={() => setHistorySideOpen(false)}
      />
      <SideBox style={{ width: 80 }} LogoComponent={Logo}>
        <SideBoxWrapper>
          <NavLink
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
              if (disabledNavigation) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            exact
            to={
              protocoloExecutado
                ? protocoloEnterpriseRoute(protocoloExecutado)
                : '#'
            }
          >
            <SideBoxButton disabled={disabledNavigation}>
              <FiServer />
            </SideBoxButton>
          </NavLink>
          <NavLink
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
              if (disabledNavigation || !hasSumario || anyRendered) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            to={`/enterprise/protocolos/${protocoloExecutado?.id}/sumario`}
          >
            <SideBoxButton
              disabled={disabledNavigation || !hasSumario || anyRendered}
              onMouseEnter={() => setShowAtendimentoSumario(true)}
              onMouseLeave={() => setShowAtendimentoSumario(false)}
            >
              <MfFile />
            </SideBoxButton>
          </NavLink>
          <SideBoxButton
            onMouseEnter={() => setShowAtendimentoInfo(true)}
            onMouseLeave={() => setShowAtendimentoInfo(false)}
          >
            <MfUser />
          </SideBoxButton>
          {showAtendimentoSumario && (
            <SideBoxInfoPopup top={165} left={104}>
              <SideBoxInfoPopupIndicator top={175} left={86}>
                <MfIndicator />
              </SideBoxInfoPopupIndicator>
              <DadosSumario />
            </SideBoxInfoPopup>
          )}
          {showAtendimentoInfo && (
            <SideBoxInfoPopup top={225} left={104}>
              <SideBoxInfoPopupIndicator top={235} left={86}>
                <MfIndicator />
              </SideBoxInfoPopupIndicator>
              <DadosAtendimento
                configs={['patient', 'encounter', 'organization']}
              />
            </SideBoxInfoPopup>
          )}

          {/* <UltimaInteracao onExpandClick={() => setHistorySideOpen(true)} /> */}
        </SideBoxWrapper>
      </SideBox>
    </Container>
  );
};

export default EnterpriseSidebar;
